import { render, staticRenderFns } from "./BookingFormFields.vue?vue&type=template&id=0db633ab&"
import script from "./BookingFormFields.vue?vue&type=script&lang=js&"
export * from "./BookingFormFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports